import { occFetch, occUrl } from "~/app/api/occ/occFetch";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { LINEAR_CONFIGURATION_REQUEST_QUOTE_CONFIRMATION_PAGE_URL } from "~/utils/url/staticUrls";

export function sendLinearRequestQuote(
  productCode: string,
  configurationCode: string | undefined,
  recipientNote: string,
  currentStepNumber: number,
  designation: string,
): Promise<boolean> {
  const data = {
    productCode: productCode,
    configurationCode: configurationCode,
    recipientNote: recipientNote,
    currentStepNumber: currentStepNumber,
    designation: designation,
  };
  return occFetch(occUrl("/requestLinearConfigurationQuote"), {
    body: JSON.stringify(data),
    method: "POST",
    headers: { "Content-Type": "application/json" },
  }).then((result) => {
    if (result.ok) {
      redirectToUrl(LINEAR_CONFIGURATION_REQUEST_QUOTE_CONFIRMATION_PAGE_URL);
      return true;
    } else {
      console.error(`Error sending linear quote request: ${result.status}`);
      throw new Error(result.status + "");
    }
  });
}
